import { ContentPreview } from '@/presentation/feature/content/components/ContentPreview';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { MediaUtils } from '@/domain/utils/mediaUtils';
import { qaAttr } from '@/presentation/utils/qaAttr';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';

interface LinkContentMediaCellProps {
  media: UserMediaEntity;
  onTap: (media: UserMediaEntity) => void;
}

export const LinkContentMediaCell = ({ media, onTap }: LinkContentMediaCellProps) => {
  const { theme } = useTheme();
  const { l10n } = useLocale();
  const thumbnailUrl = MediaUtils.getMediaThumbnailUrl(media);

  return (
    <div
      {...qaAttr({ id: `link-content-cell-${media.id}` })}
      onClick={() => onTap(media)}
      className="cursor-pointer overflow-hidden relative flex flex-col items-center justify-center"
      style={{ backgroundColor: theme.surface }}
    >
      <div
        className="hover:opacity-80 transition-opacity"
        style={{ width: '100%', aspectRatio: media.aspectRatio }}
      >
        <ContentPreview
          thumbnailUrl={thumbnailUrl}
          alt={media.title || media.description || l10n.common.videoThumbnail}
        />
      </div>
    </div>
  );
};
